<template>
  <div>
    <a-row :gutter="24" v-if="initData">
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="总客户数" :total="initData.tenant_count">
          <template slot="footer">日新增客户数 <span>{{ initData.today_tenant_count }}</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="平台打印订单数" :total="initData.print_order_count">
          <template slot="footer">日打印订单数<span> {{ initData.today_print_order_count }}</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="总充值订单数" :total="initData.recharge_order_count">
          <template slot="footer">日充值订单数 <span>{{ initData.today_recharge_order_count }}</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="总充值金额" :total="'￥'+initData.recharge_money">
          <template slot="footer">日充值金额 <span>￥ {{ initData.today_recharge_money }}</span></template>
        </chart-card>
      </a-col>
    </a-row>

    <a-row style="margin-top: 30px;">
      <a-col span="24">
        <a-card :loading="loading" :bordered="false" :body-style="{padding: '0'}">
          <div class="salesCard">
            <a-tabs default-active-key="1" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">
              <div class="extra-wrapper" slot="tabBarExtraContent">
                <div class="extra-item">
                  <a @click="handleClick('TODAY')" :class="type === 'TODAY'?'select_time':''">今日</a>
                  <a @click="handleClick('MONTH')" :class="type === 'MONTH'?'select_time':''">近30天</a>
                  <a @click="handleClick('YEAR')" :class="type === 'YEAR'?'select_time':''">近12个月</a>
                </div>
              </div>
              <a-tab-pane loading="true" tab="支付金额统计" key="1">
                <a-row>
                  <a-col
                    :xl="16"
                    :lg="12"
                    :md="12"
                    :sm="24"
                    :xs="24"
                    v-if="StatisticsData">
                    <bar title="金额" :init-data="StatisticsData" v-if="showBar"/>
                  </a-col>
                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                    <rank-list title="支付金额排行榜" :list="rankList"/>
                    <!--                    <a-empty description="暂无数据"/>-->
                  </a-col>
                </a-row>
              </a-tab-pane>
              <!--              <a-tab-pane key="2">-->
              <!--                <a-row>-->
              <!--                  <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">-->
              <!--                    <bar title="销售额趋势" />-->
              <!--                  </a-col>-->
              <!--                  <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">-->
              <!--                    <rank-list title="门店销售排行榜" :list="rankList"/>-->
              <!--                  </a-col>-->
              <!--                </a-row>-->
              <!--              </a-tab-pane>-->
            </a-tabs>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <!--    <iframe -vshow="data.pagenow_index_path !== ''" id="bdIframe" :src="data.pagenow_host + data.pagenow_index_path" frameborder="0"></iframe>-->
  </div>
</template>

<script>
import _ from 'lodash'
import { getPre, getIndex, getStatistics } from '@/api/system'
import { ChartCard, Bar, RankList } from '@/components'

const rankList = []
// for (let i = 0; i < 7; i++) {
//   rankList.push({
//     name: '积木熊 ' + (i + 1),
//     total: 1234.56 - i * 100
//   })
// }

export default {
  components: {
    ChartCard,
    RankList,
    Bar
  },
  data () {
    return {
      rankList,
      loading: true,
      pagenow_host: '',
      pagenow_index_path: '',
      initData: '',
      StatisticsData: '',
      type: 'TODAY',
      showBar: false,
      inintType: false
    }
  },
  mounted () {
    this.init()
    // // iframe-宽高自适应显示
    // const oIframe = document.getElementById('bdIframe')
    // const deviceWidth = document.body.clientWidth
    // const deviceHeight = document.body.clientHeight
    // // 数字是页面布局宽度差值
    // oIframe.style.width = (Number(deviceWidth) * 0.84) + 'px'
    // // 数字是页面布局高度差
    // oIframe.style.height = Number(deviceHeight) + 'px'
  },
  created () {
    // this.handlePre()
    setTimeout(() => {
      this.loading = !this.loading
    }, 1000)
  },
  methods: {
    handlePre () {
      getPre({ type: 'pagenow' }).then(res => {
        if (_.get(res, 'code') === 200) {
          const page = _.get(res, 'values.pageInfo', {})
          if (page && page.password !== '') {
            sessionStorage.setItem('pagePwd', page.password)
          }
          this.data = _.get(res, 'data', {})
        }
      })
    },
    init () {
      this.getIndexData()
      this.getStatisticsData()
    },
    handleClick (type) {
      this.type = type
      this.showBar = false
      this.getStatisticsData()
    },
    getIndexData () {
      getIndex().then(res => {
        if (res.code === 200) {
          this.inintType = true
          this.initData = res.data
        }
      })
    },
    getStatisticsData () {
      const params = {
        type: this.type
      }
      getStatistics(params).then(res => {
        if (res.code === 200) {
          this.showBar = true
          this.StatisticsData = res.data.money_tj
          this.rankList = res.data.tenant_tj
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .topData {
    /*width: 190px;*/
    /*padding: 20px 10px;*/
    margin-right: 40px;
    box-sizing: border-box;
  }

  .mtb10 {
    margin: 10px 0;
  }
  .num {
    font-size: 30px;
    font-weight: 700;
  }
  .extra-wrapper {
    line-height: 55px;
    padding-right: 262px;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

  a {
    margin-left: 24px;
  }
  }
  }
  .select_time {
    padding-bottom: 16px;
    border-bottom: 2px solid #24BFCF;
  }
</style>
